import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2, ShieldAlert } from 'lucide-react';
import { useIsAppAdmin } from '@/hooks/useIsAppAdmin';

interface Props {
  children: React.ReactNode;
}

/**
 * Wrapper per le route /admin/* — accessibili solo agli utenti in public.app_admins.
 * Mostra fallback minimal mentre carica + redirect /dashboard se non admin.
 */
export default function AdminGuard({ children }: Props) {
  const { isAdmin, isLoading } = useIsAppAdmin();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-zinc-400" />
      </div>
    );
  }

  if (!isAdmin) {
    // Non admin: fallback gentile invece di redirect silenzioso, così sai cos'è successo
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md text-center">
          <ShieldAlert className="h-12 w-12 text-amber-500 mx-auto mb-3" />
          <h1 className="text-lg font-semibold text-zinc-900 mb-2">Area riservata</h1>
          <p className="text-sm text-zinc-600 mb-4">
            Questa sezione è accessibile solo allo staff DryConfig (gestione catalogo, listini, stratigrafie da vendere).
          </p>
          <Navigate to="/dashboard" replace />
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
